//cancel plan pop up

import {
  Box,
  Button,
  Card,
  Dialog,
  Divider,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  archivedBriefsRequested,
  briefsRequested as activeBriefsRequested,
} from "src/slices/brief/thunks";
import { getProjects, projects, reassignBrief } from "src/slices/projects";
import { snackAdded } from "src/slices/system";
import { useDispatch, useSelector } from "src/store";
import { ExclamationHollowCircle } from "../../../icons/exclamation-hollow-circle";

interface PropsType {
  isOpen: boolean;
  setIsReassignBriefDialogOpen: (id: string) => void;

  id: string;
  briefName: string;
  projectId: string;
  tab: string;
}

export default function ReassignBriefDialog({
  isOpen,
  setIsReassignBriefDialogOpen,
  id,
  briefName,
  projectId,
  tab,
}: PropsType) {
  const dispatch = useDispatch();

  const [selectedproject, setSelectedProject] = useState("");
  const [selectedColor, setSelectedColor] = useState("#5048E5");
  const [allProjects, setAllProjects] = useState([]);
  const [clickedProject, setClickedProject] = useState(false);
  const briefsRequested =
    tab === "archived" ? archivedBriefsRequested : activeBriefsRequested;

  const Projects = useSelector(projects);
  const [selectText, setSelectText] = useState("");
  const [selectColor, setSelectColor] = useState("#5048E5");
  const [setProject, setProjectState] = useState([]);

  // const [totalBriefs, setTotalBriefs] = useState(0);

  const onClose = () => {
    setIsReassignBriefDialogOpen("");
    setSelectedProject("");
    setClickedProject(false);
    // setSelectedColor("#5048E5");
  };
  const router = useRouter();

  const formik = useFormik({
    initialValues: {
      projectName: "",
      // projectId: "",
    },
    onSubmit: async (values) => {
      // const result = await dispatch(deleteProject(id));
      // console.log("result handle delete", result)
    },
  });

  // const deleteProjectLoading = useSelector(deleteProjectLoadingState);
  // const deleteProjectFullfilled = useSelector(deleteProjectFullfilledState);
  // const deleteProjectMessage = useSelector(deleteProjectMessageState);

  const handleBrief = async () => {
    if (selectedproject === "") {
      return;
    }

    const result = await dispatch(
      reassignBrief({
        briefId: id,
        projectId: selectedproject,
        projectName: selectText,
      })
    );
    if (result) {
      dispatch(
        snackAdded({
          message: "Brief Reassigned Successfully",
          type: "success",
          duration: 3000,
        })
      );

      //re-render breif table
      // router.reload()
      dispatch(briefsRequested({ limit: 25, keyword: "", project: "All" }));
      dispatch(getProjects());

      onClose();
    }
  };

  useEffect(() => {
    dispatch(getProjects());
  }, []);

  useEffect(() => {
    setAllProjects(Projects);
    setProjectState(Projects);
  }, [Projects]);

  const filterProjects = (value) => {
    const project = setProject;
    const filteredProjects = project.filter((project) => {
      return project.projectName.toLowerCase().includes(value.toLowerCase());
    });
    setAllProjects(filteredProjects);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box width="464px">
        <Box
          display="flex"
          width="464px "
          // height="526px"
          paddingTop="8px"
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="center"
          sx={{
            position: "absolute",
            width: "100%",
            height: "8px",

            borderRadius: "4px 4px 0px 0px",
            background:
              "linear-gradient(60.66deg, #FFD875 -3.87%, #DA00C8 26.08%, #6A00FF 56.49%)",
          }}
        />

        <Box
          sx={{
            borderRadius: "0px 0px 8px 8px",
            background: "#FFFFFF",

            /* Wrapper Shadow */
            boxShadow: "0px 1px 2px 0px rgba(100, 116, 139, 0.10)",
          }}
          display="flex"
          padding="24px"
          flexDirection="column"
          alignItems="flex-start"
          gap="16px"
          alignSelf="stretch"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="flex-start"
            alignSelf="stretch"
          >
            <Typography
              color="#121828"
              /* Heading/H1 */
              fontFamily="Inter"
              fontSize="20px"
              fontStyle="normal"
              fontWeight="500"
              lineHeight="normal"
            >
              Brief:&nbsp;{briefName}
            </Typography>
            <Typography
              width="19.267px"
              height="19.267px"
              flexShrink="0"
              sx={{
                cursor: "pointer",
              }}
              onClick={() => onClose()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M2.69203 15.6063L8.66481 9.6335L2.69203 3.66072C2.46324 3.43568 2.33378 3.12787 2.33228 2.80725C2.33153 2.48588 2.45872 2.17807 2.686 1.95077C2.91329 1.72423 3.2211 1.59705 3.54248 1.59855C3.86385 1.60006 4.17091 1.72951 4.39595 1.95906L10.3664 7.93183L16.3392 1.95906C16.5642 1.72951 16.8713 1.60006 17.1927 1.59855C17.5133 1.59705 17.8218 1.72424 18.0491 1.95077C18.2764 2.17807 18.4036 2.48588 18.4021 2.80725C18.4014 3.12787 18.2719 3.43568 18.0431 3.66072L12.068 9.6335L18.0408 15.6063C18.2696 15.8313 18.399 16.1391 18.4005 16.4597C18.4013 16.7811 18.2741 17.0889 18.0468 17.3162C17.8195 17.5428 17.5117 17.6699 17.1903 17.6684C16.869 17.6669 16.5619 17.5375 16.3369 17.3079L10.3664 11.3352L4.39364 17.3079C3.9225 17.7723 3.16537 17.7693 2.69723 17.3027C2.22986 16.8353 2.2261 16.0782 2.68971 15.6063L2.69203 15.6063Z"
                  fill="#7B85AD"
                />
              </svg>
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            alignSelf="stretch"
            gap="8px"
          >
            <Typography
              color="#121828"
              fontFamily="Inter"
              fontSize="16px"
              fontStyle="normal"
              fontWeight="600"
              lineHeight="normal"
            >
              Choose project
            </Typography>
          </Box>

          {/* < Divider sx={{

                        width: 416,
                        height: 1,
                        background: "#E6E8F0",

                    }} /> */}
          <Box
            sx={
              {
                // position: "relative",
                // mt: 1,
                // ml: 3,
              }
            }
          >
            <Card
              sx={{
                //   zIndex: 100,
                //   position: "absolute",
                //   boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
                borderRadius: "4px",
                border: "1px solid #eee",
                padding: "0rem 0.8rem ",
                width: "414px",
                height: "270px",
              }}
            >
              <Box sx={{}}>
                <TextField
                  fullWidth
                  id="standard-basic"
                  label="Search"
                  variant="standard"
                  InputProps={{ disableUnderline: true }}
                  onChange={(e) => {
                    filterProjects(e.target.value);
                  }}
                />
                <Divider
                  sx={{
                    mb: 1,
                    ml: -1,
                    mr: -1,
                    backgroundColor: "blue !important",
                    color: "blue !important",
                  }}
                />
              </Box>
              {allProjects && (
                <Box
                  sx={{
                    maxHeight: "15rem",
                    overflowY: "auto",
                  }}
                >
                  <Box
                    display="flex"
                    sx={{
                      p: 1,
                    }}
                  >
                    {/* <Typography
                      color={selectedproject === project.projectId ? "#5048E5" : "#121828"}
                      fontWeight={selectedproject === "All" ? "600" : "500"}
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        textAlign: "left",

                        cursor: "pointer",
                      }}
                    //   onClick={() => {
                    //     [setSelectedProject("All"), setCurrentProject("All"), setSelectText("Filter by project"), setSelectColor("#5048E5")];
                    //   }}
                    >
                     Current Project
                    </Typography> */}
                  </Box>

                  {allProjects.map((project, index) => (
                    <Box
                      key={project.projectId}
                      display="flex"
                      sx={{
                        p: 1,
                      }}
                    >
                      <Typography
                        color={
                          selectedproject === project.projectId ||
                          (projectId === project.projectId && !clickedProject)
                            ? "#5048E5"
                            : "#121828"
                        }
                        fontWeight={
                          selectedproject === project.projectId ||
                          (projectId === project.projectId && !clickedProject)
                            ? "600"
                            : "500"
                        }
                        sx={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          textAlign: "left",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          [
                            setSelectedProject(project.projectId),
                            setSelectText(project.projectName),
                            setSelectColor("#121828"),
                            setClickedProject(true),
                          ];
                        }}
                      >
                        {/* if projectId == project.projectId show that index first */}

                        {project.projectName}
                      </Typography>
                      <Tooltip
                        title={project.projectDomain}
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "#000",
                              "& .MuiTooltip-arrow": {
                                color: "common.black",
                                borderRadius: "4px",
                              },
                            },
                          },
                        }}
                        placement="top"
                      >
                        <ExclamationHollowCircle
                          sx={{
                            ml: "5px",
                            mt: "5px",
                            cursor: "pointer",
                            fontSize: "1.2rem",
                          }}
                        />
                      </Tooltip>
                      <Typography
                        color={
                          selectedproject === project.projectId
                            ? "#5048E5"
                            : "#121828"
                        }
                        sx={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          float: "right",
                          ml: "auto",

                          fontWeight: "500",
                        }}
                      >
                        {project.briefCount}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
              {/* Create Project Button */}
            </Card>
          </Box>

          {/* < Divider sx={{
                        width: 416,
                        height: 1,
                        background: "#E6E8F0"
                    }} /> */}

          <Box display="flex" gap="32px" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              // onClick={}
              size="large"
              // disabled={isLoading || selected.length <= 0}
              sx={{
                display: "flex",
                padding: "8px 22px",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                gap: "8px",
                borderRadius: "4px",

                background: "#5048E5",
                color: "#FFFFFF",
                fontFamily: "Inter",
                width: "183px",

                "&:hover": {
                  background: "#5048E5",
                  color: "#FFFFFF",
                },
              }}
              onClick={() => handleBrief()}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                router.push({
                  pathname: "/projects/settings/",
                  query: {
                    url: "new",
                  },
                });
              }}
              sx={{
                fontSize: "14px",
                fontWeight: "600",
                fontFamily: "Inter",
                color: "#5048E5",
                float: "left",

                // marginTop: "0.5rem",
                // marginBottom: "1.5rem",
                borderRadius: "4px",
                padding: " 8px 22px",
                // width:'141px'
              }}
            >
              Create Project
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
}
